"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BucketStrategy = void 0;
var BucketStrategy;
(function (BucketStrategy) {
    /** For count-like attributes, where count since last reading should be apportioned across preceding buckets */
    BucketStrategy["APPORTION"] = "APPORTION";
    /** For reading-like attributes ( eg temperature), where the values going into one bucket as essentially averaged, and for intervening buckets should be inferred by some regression strategy */
    BucketStrategy["INFERREADING"] = "INFERREADING";
    /** Maximums, for example max temperature */
    BucketStrategy["MAXIMUM"] = "MAXIMUM";
    /** Minimum */
    BucketStrategy["MINIMUM"] = "MINIMUM";
    // TODO: add an "average" option where readings ain the bucket are averaged with the current value of the bucket.
    // This might just be a CMVarAggregationObject though
    // TODO: add a "replace" option that just replaced the value in the bucket when given a reading
})(BucketStrategy || (exports.BucketStrategy = BucketStrategy = {}));
